export { OfferWidget } from './offer';
